export const ROUTE_FAN_BOX_MESSAGE_ROOT = '/fanbox';
export const ROUTE_FAN_BOX_MESSAGE_EDIT = ROUTE_FAN_BOX_MESSAGE_ROOT + '/edit/:id';
export const ROUTE_FAN_BOX_MESSAGE_NEW = ROUTE_FAN_BOX_MESSAGE_ROOT + '/new';



// WEBPACK FOOTER //
// ./src/components/FanBox/constants.js